import { Css, sm } from "src/Css";

export function Footer() {
  return (
    <div css={Css.pt3.pb2.asfe.if(sm).asc.$}>
      <div css={Css.sm.midGray.$}>© Homebound Technologies, Inc. {new Date().getFullYear()}</div>
    </div>
  );
}
